import { render } from "./OrderReturnSpecs.vue?vue&type=template&id=38753840&scoped=true&ts=true&lang=pug"
import script from "./OrderReturnSpecs.vue?vue&type=script&lang=ts"
export * from "./OrderReturnSpecs.vue?vue&type=script&lang=ts"

import "./OrderReturnSpecs.vue?vue&type=style&index=0&id=38753840&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38753840"]])

export default __exports__